module.exports = __webpack_public_path__ + "img/logo.67bdf8f9.png";